module.exports = __webpack_public_path__ + "img/contact_send_sample.7dc8c884.jpeg";